// generated by the plop

import { EnterpriseModel } from 'shared';
import { PROGRESS_STATUSES } from 'symbols';

export interface EnterpriseStateModel {
  enterpriseList: EnterpriseModel[];
  loadEnterpriseListStatus: PROGRESS_STATUSES;
}

export const ENTERPRISE_STATE_DEFAULT: EnterpriseStateModel = {
  enterpriseList: [],
  loadEnterpriseListStatus: PROGRESS_STATUSES.NOT_INITIALIZED
};
